import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { clearLocalStorageData } from "../../../../shared/utils/localStorage";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    clearLocalStorageData();
    sessionStorage.clear();

    navigate("/login", { replace: true });
  }, [navigate]);

  return null; // no UI needed
};

export default Logout;
